import React, { useCallback, useContext, useEffect, useState } from 'react'
import Header from '../components/Header';
import Footer from '../components/Footer';
import Menu from '../components/Menu';
import axios from 'axios';
import { LoadingContext } from '../context/LoadingContext';
import ReactLoader from '../components/ReactLoader';
const config = require('../config.json')


export default function Downline({ ipAddress, loginData }) {
  const [info, setDownline] = useState({});
  const [loading, setLoading] = useContext(LoadingContext)
  const [dr, setDr] = useState(false);
  const [lh, setLh] = useState(false);
  const [rh, setRh] = useState(false);
  const handleDownline = useCallback(() => {
    setLoading(true)
    let data = JSON.stringify({
      "ip": ipAddress,
      "ulid": loginData.ulid
    });

    let axiosConfig = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${config.baseUrl}downline`,
      headers: {
        'ip': ipAddress,
        'ulid': loginData.ulid,
        'auth': loginData.auth,
        'token': loginData.token,
        'Content-Type': 'application/json'
      },
      data: data
    };
    // console.log(axiosConfig)
    axios.request(axiosConfig)
      .then((response) => {
        console.log(response.data)
        setDownline(response.data?.info)
        setLoading(false)
      })
      .catch((error) => {
        console.log(error);
      });
  }, [ipAddress, loginData.auth, loginData.token, loginData.ulid, setLoading])

  useEffect(() => {
    handleDownline()
  }, [handleDownline])

  return (
    <>
      <div className="layout-container">
        <Menu />
        <div className="layout-page">
          <Header />
          {loading ? <><ReactLoader /></> :
            <div className="content-wrapper mb-4">
              <div className="container-xxl flex-grow-1 container-p-y pt-2">
                <div>
                  <div className="row">
                    <div className="col-md-12  mb-2">
                      <div className="card h-100">
                        <div
                          className="card-header align-items-center"
                          style={{ padding: "4% 5% 5% 5%" }}
                        >
                          <div className="col-md-12">
                            <div className="row d-flex justify-content-between">
                              <div className="col-12 text-center">
                                <p className="card-text m-0 text-black  text-md">
                                  <b>Direct</b>
                                </p>
                                <div className='row d-flex justify-content-between'>
                                  <div className='col-6 ' style={{ textAlignLast: "start" }}>
                                    <small className="text-sm">Diract : {parseInt(info?.diract)}</small>
                                  </div>
                                  <div className='col-6' style={{ textAlignLast: "end" }}>
                                    <small className="text-sm">Diract Active :  {parseInt(info?.diracta)}</small>
                                  </div>
                                </div>
                                <div className='row d-flex justify-content-between'>
                                  <div className='col-6 ' style={{ textAlignLast: "start" }}>
                                    <small className="text-sm">Inactive : {parseInt(info?.diract) - parseInt(info?.diracta)}</small>
                                  </div>
                                  <div className='col-6' style={{ textAlignLast: "end" }}>
                                    <small className="text-sm">Business : <i className="bx bx-rupee bx-xs"></i> {info?.diractb?.dp} (DP)</small>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12  mb-2">
                      <div className="card h-100">
                        <div
                          className="card-header align-items-center"
                          style={{ padding: "4% 5% 5% 5%" }}
                        >
                          <div className="col-md-12">
                            <div className="row d-flex justify-content-between">
                              <div className="col-12 text-center">
                                <p className="card-text m-0 text-black  text-md">
                                  <b>Left</b>
                                </p>
                                <div className='row d-flex justify-content-between'>
                                  <div className='col-6 ' style={{ textAlignLast: "start" }}>
                                    <small className="text-sm">Total : {parseInt(info?.left)}</small>
                                  </div>
                                  <div className='col-6' style={{ textAlignLast: "end" }}>
                                    <small className="text-sm">Active :  {parseInt(info?.lefta)}</small>
                                  </div>
                                </div>
                                <div className='row d-flex justify-content-between'>
                                  <div className='col-6 ' style={{ textAlignLast: "start" }}>
                                    <small className="text-sm">Inactive : {parseInt(info?.left) - parseInt(info?.lefta)}</small>
                                  </div>
                                  <div className='col-6' style={{ textAlignLast: "end" }}>
                                    <small className="text-sm">Business :(BV)  {info?.leftb?.bv}</small>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12  mb-2">
                      <div className="card h-100">
                        <div
                          className="card-header align-items-center"
                          style={{ padding: "4% 5% 5% 5%" }}
                        >
                          <div className="col-md-12">
                            <div className="row d-flex justify-content-between">
                              <div className="col-12 text-center">
                                <p className="card-text m-0 text-black  text-md">
                                  <b>Right</b>
                                </p>
                                <div className='row d-flex justify-content-between'>
                                  <div className='col-6 ' style={{ textAlignLast: "start" }}>
                                    <small className="text-sm">Total : {parseInt(info?.right)}</small>
                                  </div>
                                  <div className='col-6' style={{ textAlignLast: "end" }}>
                                    <small className="text-sm">Active :  {parseInt(info?.righta)}</small>
                                  </div>
                                </div>
                                <div className='row d-flex justify-content-between'>
                                  <div className='col-6 ' style={{ textAlignLast: "start" }}>
                                    <small className="text-sm">Inactive : {parseInt(info?.right) - parseInt(info?.righta)}</small>
                                  </div>
                                  <div className='col-6' style={{ textAlignLast: "end" }}>
                                    <small className="text-sm">Business : (BV)  {info?.rightb?.bv}</small>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-md-12 text-center mb-2'>
                      <div className="btn-group justify-content-around" style={{ width: '100%' }}>
                        <button type="button" className="btn btn-info text-sm" jf-ext-button-ct="left" onClick={() => { setDr(true); setLh(false); setRh(false); }}>Direct Team</button>
                        <button type="button" className="btn btn-warning text-sm" jf-ext-button-ct="middle" onClick={() => { setDr(false); setLh(true); setRh(false); }}>Left Team</button>
                        <button type="button" className="btn btn-primary text-sm" jf-ext-button-ct="middle" onClick={() => { setDr(false); setLh(false); setRh(true); }}>Right Team</button>
                        {/* <button type="button" className="btn btn-warning text-sm" jf-ext-button-ct="right" onClick={() => { setWith(false); setReci(false); setSelf(false); setTran(true) }}>Send Other</button> */}
                      </div>
                    </div>
                  </div>
                  {(dr) &&
                    <div className='row'>
                      {
                        info?.drList?.map((list, index) => {

                          return (
                            <div className="col-md-4  mb-1" key={index + 1}>
                              <div className="card h-100">
                                <div className="card-header align-items-center" style={{ padding: "3% 5% 3% 5%" }}>
                                  <div className="col-md-12">
                                    <div className='row d-flex justify-content-between'>
                                      <div className='col-6 text-left'>
                                        <span className="text-black text-sm"> {list?.name} ({list?.ulid})</span>
                                      </div>
                                      <div className='col-6' style={{ textAlignLast: "end" }}>
                                        <span className={`${(list.active > 0) ? 'text-black text-sm rounded-pill btn btn-success btn-xs' : 'text-danger text-sm rounded-pill btn btn-info btn-xs'}`} style={{ fontSize: "14px" }}>{(list?.active > 0) ? 'Active' : 'In-active'}</span>
                                      </div>
                                    </div>
                                    {/* <div className='row d-flex justify-content-between'>
                                      <div className='col-6 text-left'>
                                        <small className="text-sm">{list?.email}</small>
                                      </div>
                                      <div className='col-6' style={{ textAlignLast: "end" }}>
                                        <small className="text-sm">{list?.mobile}</small>
                                      </div>
                                    </div> */}
                                    <div className='row d-flex justify-content-between'>
                                      <div className='col-6 text-left'>
                                        <small className="text-sm">Parent :  {list?.pname}</small>
                                      </div>
                                      <div className='col-6' style={{ textAlignLast: "end" }}>
                                        <small className="text-sm">{list?.plid} ({list?.pside})</small>
                                      </div>
                                    </div>
                                    <div className='row d-flex justify-content-between'>
                                      <div className='col-6 text-left'>
                                        <small className="text-sm">Side- {list?.sside}</small>
                                      </div>
                                      <div className='col-6' style={{ textAlignLast: "end" }}>
                                        <small className="text-sm">BV : {list?.bv}</small>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>
                  }
                  {(lh) &&
                    <div className='row'>
                      {
                        info?.leftList?.map((list, index) => {

                          return (
                            <div className="col-md-4  mb-1" key={index + 1}>
                              <div className="card h-100">
                                <div className="card-header align-items-center" style={{ padding: "3% 5% 3% 5%" }}>
                                  <div className="col-md-12">
                                    <div className='row d-flex justify-content-between'>
                                      <div className='col-6 text-left'>
                                        <span className="text-black text-sm"> {list?.name} ({list?.ulid})</span>
                                      </div>
                                      <div className='col-6' style={{ textAlignLast: "end" }}>
                                        <span className={`${(list.active > 0) ? 'text-black text-sm rounded-pill btn btn-success btn-xs' : 'text-danger text-sm rounded-pill btn btn-info btn-xs'}`} style={{ fontSize: "14px" }}>{(list?.active > 0) ? 'Active' : 'In-active'}</span>
                                      </div>
                                    </div>
                                    {/* <div className='row d-flex justify-content-between'>
                                      <div className='col-6 text-left'>
                                        <small className="text-sm">{list?.email}</small>
                                      </div>
                                      <div className='col-6' style={{ textAlignLast: "end" }}>
                                        <small className="text-sm">{list?.mobile}</small>
                                      </div>
                                    </div> */}
                                    <div className='row d-flex justify-content-between'>
                                      <div className='col-6 text-left'>
                                        <small className="text-sm">Parent :  {list?.pname}</small>
                                      </div>
                                      <div className='col-6' style={{ textAlignLast: "end" }}>
                                        <small className="text-sm">{list?.plid} ({list?.pside})</small>
                                      </div>
                                    </div>
                                    <div className='row d-flex justify-content-between'>
                                      <div className='col-6 text-left'>
                                        <small className="text-sm">Level- {list?.tlevel}</small>
                                      </div>
                                      <div className='col-6' style={{ textAlignLast: "end" }}>
                                        <small className="text-sm">BV : {list?.bv}</small>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>
                  }
                  {(rh) &&
                    <div className='row'>
                      {
                        info?.rightList?.map((list, index) => {

                          return (
                            <div className="col-md-4  mb-1" key={index + 1}>
                              <div className="card h-100">
                                <div className="card-header align-items-center" style={{ padding: "3% 5% 3% 5%" }}>
                                  <div className="col-md-12">
                                    <div className='row d-flex justify-content-between'>
                                      <div className='col-6 text-left'>
                                        <span className="text-black text-sm"> {list?.name} ({list?.ulid})</span>
                                      </div>
                                      <div className='col-6' style={{ textAlignLast: "end" }}>
                                        <span className={`${(list.active > 0) ? 'text-black text-sm rounded-pill btn btn-success btn-xs' : 'text-danger text-sm rounded-pill btn btn-info btn-xs'}`} style={{ fontSize: "14px" }}>{(list?.active > 0) ? 'Active' : 'In-active'}</span>
                                      </div>
                                    </div>
                                    {/* <div className='row d-flex justify-content-between'>
                                      <div className='col-6 text-left'>
                                        <small className="text-sm">{list?.email}</small>
                                      </div>
                                      <div className='col-6' style={{ textAlignLast: "end" }}>
                                        <small className="text-sm">{list?.mobile}</small>
                                      </div>
                                    </div> */}
                                    <div className='row d-flex justify-content-between'>
                                      <div className='col-6 text-left'>
                                        <small className="text-sm">Parent :  {list?.pname}</small>
                                      </div>
                                      <div className='col-6' style={{ textAlignLast: "end" }}>
                                        <small className="text-sm">{list?.plid} ({list?.pside})</small>
                                      </div>
                                    </div>
                                    <div className='row d-flex justify-content-between'>
                                      <div className='col-6 text-left'>
                                        <small className="text-sm">Level- {list?.tlevel}</small>
                                      </div>
                                      <div className='col-6' style={{ textAlignLast: "end" }}>
                                        <small className="text-sm">BV : {list?.bv}</small>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>
                  }
                </div>
              </div>
              <Footer />
            </div>}
        </div>
      </div>

    </>
  );
}